export default "/js/4f9b5e69f4f2583d972d06fda44e34c3.ttf";